// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/scheduler/routes/ViewScheduler/components/DayInitialiser/DayInitialiser.scss
// module id = 801
// module chunks = 0